import React from 'react';
import cn from 'classnames';
import classes from './patagonia-card.scss';
const PatagoniaCard = ({
  item,
  className,
  isFilterPopupOpen
}) => {
  const {
    childProductIds = [],
    title = ''
  } = item;
  const patagoniaProductsQuantity = childProductIds.length;
  const patagoniaTitle = title.replace('__', ' ');
  return /*#__PURE__*/React.createElement("div", {
    className: cn(className, {
      [classes.openedFilter]: isFilterPopupOpen
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.patagoniaName
  }, patagoniaTitle), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.leftAlign
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.patagoniaQuantity
  }, patagoniaProductsQuantity, /*#__PURE__*/React.createElement("span", {
    className: classes.patagoniaTextLeft
  }, patagoniaProductsQuantity === 1 ? 'Product available' : 'Products available'))), /*#__PURE__*/React.createElement("div", {
    className: classes.rightAlign
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.patagoniaTextRight
  }, "Find ", /*#__PURE__*/React.createElement("span", {
    className: classes.additionalText
  }, "out"), " more \xA0>"))));
};
export default PatagoniaCard;